import { render } from "./TranscriptionBotPromptPanel.vue?vue&type=template&id=09788125&scoped=true"
import script from "./TranscriptionBotPromptPanel.vue?vue&type=script&lang=js"
export * from "./TranscriptionBotPromptPanel.vue?vue&type=script&lang=js"

import "./TranscriptionBotPromptPanel.vue?vue&type=style&index=0&id=09788125&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09788125"

export default script